import { FooterHelp, Link, Banner } from '@shopify/polaris'

export default function Footer() {
  return (
    <FooterHelp>
      <Banner>
        Got any trouble or have recommendations with this new app? Mail us at{' '}
        <Link url="mailto:steve@upatra.com" external>
          steve@upatra.com
        </Link>
      </Banner>
    </FooterHelp>
  )
}
